// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__27wTn","containerItemsCenter":"Skeleton_containerItemsCenter__2thDg"};